import React from 'react'

import { useIntl } from '@app/intl/Intl'
import { Dialog, DialogContent } from '@app/lib/disclosure/Dialog/Dialog'
import { UseDialogReturn } from '@app/lib/disclosure/Dialog/useDialog'
import { Heading } from '@app/lib/typography/Heading/Heading'

import { ReportProblemForm } from './ReportProblemForm'

type ReportProblemDialogProps = Pick<UseDialogReturn, 'dialogProps' | 'closeDialog'>

export const ReportProblemDialog = ({ dialogProps, closeDialog }: ReportProblemDialogProps) => {
  const { formatMessage } = useIntl()

  return (
    <Dialog {...dialogProps}>
      <DialogContent
        title={<Heading>{formatMessage({ id: 'ReportProblem.Popup.Title' })}</Heading>}
        size='lg'
      >
        <ReportProblemForm closeDialog={closeDialog} />
      </DialogContent>
    </Dialog>
  )
}
